import {  Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import paymentOptionsConstant from 'src/app/shared/paymentOptionsConstant';
import { FetchRolesReportService } from '../../../roles/manage-roles/fetch-roles-report.service';
import { GetCashApi } from '../services/get-cash-api-status.service';
import { GetStatusProfileService } from '../services/get-status-profile.service';
import { FetchPaymentGroupFullDetails } from 'src/app/shared/services/fetch-payment-group-full-details.service';
@Component({
  selector: 'app-business-details',
  templateUrl: './business-details.component.html',
  styleUrls: ['./business-details.component.scss']
})
export class BusinessDetailsComponent implements OnInit {


  withdrwaStatus: boolean;
  pendingToAvailable !: string;
  creditCardLimit !: number;
  contractStatus: boolean;
  productBrowseStatus: boolean;
  cashApiStatus: boolean;
  marchantPercentage: string;
  businessId: string;
  qassatlyStatus: boolean;
  qassatlyLimit: string;
  qassatlyMonthlyLimit: string;
  advanceSalesStatus: boolean;
  availableFeesStatus: boolean;
  availableFeesPercentage: string;
  merchantID: number;
  advanceSalesLimit: string;
  payment_options: Array<{id:number,name:string,value:string,[key:string]:any}>[] = [];
  businessStatus: string = "";
  sellerId: string;
  adminOrSellerRoleId!: number;
  adminOrSellerRoleName!: string;
  normalFees: number;
  urgentFees: number;
  constructor(
    private getStatusProfileService: GetStatusProfileService,
    private activatedRoute: ActivatedRoute,
    private getCashApi: GetCashApi,
    public fetchRoles: FetchRolesReportService,
    private fetchPaymentGroupFullDetails: FetchPaymentGroupFullDetails
  ) { }
  async ngOnInit() {
    this.activatedRoute.params.subscribe(async params => {
      this.businessId = params["id"];
      this.getStatusProfileService.setParams({ id: params["id"] });

      const paymentOptionsData = await this.fetchPaymentGroupFullDetails.make()
      const response = await this.getStatusProfileService.make();

      this.normalFees = response.bushiness.normalFees;
      this.urgentFees = response.bushiness.urgentFees;
      this.contractStatus = response.bushiness.contractStatus === 'signed';
      this.productBrowseStatus = response.res[0].productBrowseFlag > 0;
      this.advanceSalesLimit = response.bushiness.advancedSalesLimit
      if (response.bushiness.advancedSalesLimit == null) {
        this.advanceSalesStatus = false
      } else {
        this.advanceSalesStatus = true
      }
       this.withdrwaStatus = !!response.res[0].can_withdraw;
      this.payment_options = paymentOptionsData.map((option: any) => ({
        name: option.name,
        fees: option.fees
      }));
      this.sellerId = response.res[0].sellerId;



      const qassatlyId = response.res[0].qassatlyId;
      this.qassatlyStatus = !!qassatlyId;
      if (!this.qassatlyStatus) {
        //default value if no qassatly status returned from the database
       this.qassatlyLimit = "800";
       this.qassatlyMonthlyLimit = "5000"
      } else {
         this.qassatlyLimit =
          response.res[0].qassatlyLimit;
      this.qassatlyMonthlyLimit =
          response.res[0].qassatlyMonthlyLimit;
      }




      this.merchantID = qassatlyId;


      this.getCashApi.setParams({ businessId: this.businessId });
      const cashApiKey = await this.getCashApi.make();
       this.cashApiStatus = cashApiKey.enabled;

      this.availableFeesStatus = !!response.bushiness.availableFeesPercentage;

    this.availableFeesPercentage = response.bushiness.availableFeesPercentage;

      this.pendingToAvailable =response.bushiness.pendingToAvailable;

      this.marchantPercentage = response.res[0].fees;

      this.creditCardLimit = +response.bushiness.creditCardLimit;
    this.businessStatus = response.bushiness.activeStatus;

      this.adminOrSellerRoleId = response.res[0].RoleId;
      this.fetchRoles.setParams({});
      const report = await this.fetchRoles.make();

      let roleData = report.result.filter((role: { id: number;name:string;[key:string]:any }) => {

        return role.id == this.adminOrSellerRoleId;
      }) || [];

      this.adminOrSellerRoleName = roleData[0].name;

    });


  }
   isPaymentOptionEnable(paymentOption){
    const QassatylPaymentOption=paymentOptionsConstant.constantPaymentOptions.value.QASSATLY ;
    let isEnabled;
     switch(paymentOption){
       case QassatylPaymentOption:
          isEnabled=this.qassatlyStatus;
          break;
        default:
          isEnabled=true;

     }
    return isEnabled;
  }
}
